import React, { useContext, useEffect, useState } from 'react';
import Close from '../../../assets/svgs/Close.svg';
import { StoryblokAsset } from '../../../interfaces/Storyblok/StoryblokAsset.interface';
import Image from '../../atoms/Image/Image.atom';
import TemplateContext from '../../../contexts/TemplateContext';
import { ButtonProps } from '../../../interfaces/Button.interface';
import Button from '../../atoms/Button/Button.component';
import { ButtonTypes } from '../../../interfaces/enums/ButtonTypes.enum';
import { ButtonSizeTypes } from '../../../interfaces/enums/ButtonSizeTypes.enum';

interface BannerProps {
  icon: StoryblokAsset;
  heading: string;
  subheading: string;
  handleClose: () => void;
  cta: ButtonProps[];
}

const Banner: React.FC<BannerProps> = ({ icon, heading, subheading, handleClose, cta }) => {
  return (
    <div className="!bg-sherpa-blue-500 bg-SP2 !text-sherpa-body text-Primary-900">
      <div className="container mx-auto flex md:flex-row justify-between py-4">
        <div className="flex items-center gap-3 md:mx-auto">
          <div className="hidden md:block">
            <Image image={icon} maxWidth={40} maxHeight={40} />
          </div>
          <div className="flex flex-col lg:flex-row items-start lg:items-center lg:gap-3">
            <div className="font-semibold">{heading}</div>

            <div className="font-extrabold">{subheading}</div>
            {cta && !!cta.length && cta[0].label && cta[0].link && (
              <Button
                link={cta[0].link}
                label={cta[0].label}
                type={ButtonTypes.PRIMARY}
                size={ButtonSizeTypes.SM}
                className={
                  'w-auto bg-Primary-900 hover:bg-Primary-900 !text-White !px-4 !py-3 !text-sm mr-3 mt-3 lg:mt-0'
                }
              />
            )}
          </div>
        </div>
        <button onClick={handleClose} aria-label="Close Banner">
          <Close className="text-sherpa-body" />
        </button>
      </div>
    </div>
  );
};

export default Banner;
